import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 33,
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		y: 13.5247,
		width: 33,
		height: 5.95082,
		fill: "#EE5F87"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 13.5246,
		y: 33,
		width: 33,
		height: 5.95082,
		transform: "rotate(-90 13.5246 33)",
		fill: "#EE5F87"
	})]
});
export default SvgPlusIcon;
